import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function NotifyForm() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      if (data.success) {
        setDone(true);
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="flex flex-col items-center gap-4"
        data-testid="signup-success"
      >
        <div className="h-px w-16 bg-[#C5A059]" />
        <p className="font-serif text-2xl font-light italic text-[#1A1A1A]">You're on the list.</p>
        <p className="text-sm tracking-wide text-[#4A4A4A]">Be the first to know when we launch.</p>
      </motion.div>
    );
  }

  return (
    <form onSubmit={submit} className="w-full max-w-md" data-testid="notify-form">
      <div className="flex items-center gap-3 border-b border-[#C5A059] pb-3 focus-within:border-[#9E7B3A] transition-colors duration-300">
        <input
          type="email"
          aria-label="Email address"
          data-testid="email-signup-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 bg-transparent text-base text-[#1A1A1A] placeholder:text-[#1A1A1A]/35 focus:outline-none tracking-wide"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="email-signup-submit"
          className="group flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#1A1A1A] hover:text-[#9E7B3A] disabled:opacity-50 transition-colors duration-300"
        >
          {loading ? "Joining" : "Notify Me"}
          <ArrowRight className="w-4 h-4 text-[#C5A059] transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </form>
  );
}
